"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _immutable = require("immutable");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _default = function _default(WrappedComponent) {
  return (0, _createReactClass.default)({
    displayName: "EnsureAvailableDate(" + WrappedComponent.displayName + ")",
    propTypes: {
      isSelectedDateAvailable: _propTypes.default.bool,
      compact: _propTypes.default.bool,
      setEventDate: _propTypes.default.func.isRequired,
      availableDateOptions: _propTypes.default.instanceOf(_immutable.Seq).isRequired,
      isFetchingPublicAvailability: _propTypes.default.bool.isRequired,
      isFetchingPublicOwnerAvailability: _propTypes.default.bool.isRequired
    },
    UNSAFE_componentWillMount: function UNSAFE_componentWillMount() {
      var _this$props = this.props,
          compact = _this$props.compact,
          availableDateOptions = _this$props.availableDateOptions,
          isSelectedDateAvailable = _this$props.isSelectedDateAvailable,
          setEventDate = _this$props.setEventDate;

      if (!compact && !isSelectedDateAvailable) {
        setEventDate(availableDateOptions.min());
      }
    },
    UNSAFE_componentWillReceiveProps: function UNSAFE_componentWillReceiveProps(nextProps) {
      var _this$props2 = this.props,
          publicAvailabilityWasLoading = _this$props2.isFetchingPublicAvailability,
          ownerAvailabilityWasLoading = _this$props2.isFetchingPublicOwnerAvailability,
          compact = _this$props2.compact;
      var publicAvailabilityLoading = nextProps.isFetchingPublicAvailability,
          ownerAvailabilityLoading = nextProps.isFetchingPublicOwnerAvailability,
          isSelectedDateAvailable = nextProps.isSelectedDateAvailable,
          availableDateOptions = nextProps.availableDateOptions,
          setEventDate = nextProps.setEventDate;
      var publicWasLoading = publicAvailabilityWasLoading && !publicAvailabilityLoading;
      var publicOwnerWasLoading = ownerAvailabilityWasLoading && !ownerAvailabilityLoading;

      if (publicWasLoading || publicOwnerWasLoading) {
        if (!compact && !isSelectedDateAvailable) {
          setEventDate(availableDateOptions.min());
        }
      }
    },
    render: function render() {
      var _this$props3 = this.props,
          __isSelectedDateAvailable = _this$props3.isSelectedDateAvailable,
          otherProps = (0, _objectWithoutProperties2.default)(_this$props3, ["isSelectedDateAvailable"]);
      return _react.default.createElement(WrappedComponent, otherProps);
    }
  });
};

exports.default = _default;
module.exports = exports.default;